class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="quantity"]');
    this.plusButton = this.querySelector('button[name="plus"]');
    this.minusButton = this.querySelector('button[name="minus"]');
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  connectedCallback() {
    if (!this.input) return;

    this.syncRulesFromInput();

    this.plusButton?.addEventListener('click', this.onButtonClick);
    this.minusButton?.addEventListener('click', this.onButtonClick);

    // Keep button disabled states in sync even when quantity is updated programmatically
    // (e.g. Sticky ATC +/- syncing the main product quantity input).
    this.input.addEventListener('change', this.onInputChange);
    this.input.addEventListener('input', this.onInputChange);

    this.updateButtons();
  }

  disconnectedCallback() {
    this.plusButton?.removeEventListener('click', this.onButtonClick);
    this.minusButton?.removeEventListener('click', this.onButtonClick);
    this.input?.removeEventListener('change', this.onInputChange);
    this.input?.removeEventListener('input', this.onInputChange);
  }

  syncRulesFromInput() {
    if (!this.input) return;
    this.min = this.input.min ? parseInt(this.input.min, 10) : 1;
    this.max = this.input.max ? parseInt(this.input.max, 10) : null;
    this.step = this.input.step ? parseInt(this.input.step, 10) : 1;
  }

  onButtonClick(event) {
    event.preventDefault();

    this.syncRulesFromInput();

    const isPlus = event.currentTarget.name === 'plus';
    const currentValue = parseInt(this.input.value, 10) || this.min;

    let newValue = isPlus
      ? currentValue + this.step
      : currentValue - this.step;

    if (this.max !== null) {
      newValue = Math.min(newValue, this.max);
    }

    newValue = Math.max(newValue, this.min);

    if (newValue !== currentValue) {
      this.input.value = newValue;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.updateButtons();
  }

  onInputChange() {
    this.syncRulesFromInput();
    this.updateButtons();
  }

  updateButtons() {
    const value = parseInt(this.input.value, 10);

    if (this.minusButton) {
      this.minusButton.disabled = value <= this.min;
    }

    if (this.plusButton && this.max !== null) {
      this.plusButton.disabled = value >= this.max;
    }
  }
}
customElements.define('quantity-input', QuantityInput);
